/* Revolution Power — Custom Shopify Theme JS
   Vanilla JS, no dependencies, rp- namespace throughout */

'use strict';

/* ─── Helpers ─────────────────────────────────────────────────────────────────── */

function rpFmt(cents) {
  return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function rpGet(url) {
  return fetch(url, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); });
}

function rpPost(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  }).then(function(r) { return r.json().then(function(data) { return { ok: r.ok, status: r.status, data: data }; }); });
}

function rpChange(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  }).then(function(r) { return r.json(); });
}

/* ─── Aria-live announcer ──────────────────────────────────────────────────────── */
var rpAnnouncer = null;
function rpAnnounce(msg) {
  if (!rpAnnouncer) {
    rpAnnouncer = document.createElement('div');
    rpAnnouncer.setAttribute('role', 'status');
    rpAnnouncer.setAttribute('aria-live', 'polite');
    rpAnnouncer.setAttribute('aria-atomic', 'true');
    rpAnnouncer.className = 'rp-sr-only';
    document.body.appendChild(rpAnnouncer);
  }
  rpAnnouncer.textContent = '';
  setTimeout(function() { rpAnnouncer.textContent = msg; }, 50);
}

/* ─── Cart count update ───────────────────────────────────────────────────────── */
function rpUpdateCartCount() {
  rpGet('/cart.js').then(function(cart) {
    var badges = document.querySelectorAll('.rp-cart-count');
    badges.forEach(function(b) {
      b.textContent = cart.item_count;
      b.dataset.count = cart.item_count;
    });
  }).catch(function() {});
}

/* ─── Mobile menu ─────────────────────────────────────────────────────────────── */
function rpInitMobileMenu() {
  var toggle = document.getElementById('rp-menu-toggle');
  var dialog = document.getElementById('rp-mobile-menu');
  var closeBtn = document.getElementById('rp-mobile-close');
  if (!toggle || !dialog) return;

  var scrollY = 0;

  function openMenu() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    dialog.showModal();
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    dialog.close();
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }

  toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  /* Tap-outside to close */
  dialog.addEventListener('click', function(e) {
    var inner = dialog.querySelector('.rp-mobile-menu-inner');
    if (inner && !inner.contains(e.target)) closeMenu();
  });

  /* Close when resizing to desktop */
  var mql = window.matchMedia('(min-width: 1024px)');
  function onBreakpoint(e) { if (e.matches && dialog.open) closeMenu(); }
  if (mql.addEventListener) mql.addEventListener('change', onBreakpoint);
  else mql.addListener(onBreakpoint);
}

/* ─── Product page ────────────────────────────────────────────────────────────── */
function rpInitProduct(section) {
  var dataEl = section.querySelector('[data-product-json]');
  if (!dataEl) return;

  var product;
  try {
    product = JSON.parse(dataEl.dataset.productJson);
  } catch(e) {
    return;
  }

  /* Build variant lookup map */
  var variantMap = {};
  product.variants.forEach(function(v) { variantMap[v.id] = v; });

  /* Gallery */
  var mainImg = section.querySelector('.rp-gallery__main img');
  var thumbs = section.querySelectorAll('.rp-gallery__thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
    });
  });

  /* Variant select(s) */
  var variantSelects = section.querySelectorAll('[data-option-index]');
  var priceEl = section.querySelector('[data-price]');
  var comparePriceEl = section.querySelector('[data-compare-price]');
  var unavailableMsg = section.querySelector('.rp-unavailable-msg');
  var atcBtn = section.querySelector('[data-atc-btn]');

  function getCurrentVariant() {
    if (product.variants.length === 1) return product.variants[0];
    var selected = {};
    variantSelects.forEach(function(sel) {
      selected[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
    });
    return product.variants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selected[i]; });
    }) || null;
  }

  function updateUI(variant) {
    if (!variant) {
      if (unavailableMsg) unavailableMsg.style.display = 'block';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Unavailable';
      }
      return;
    }

    if (unavailableMsg) unavailableMsg.style.display = variant.available ? 'none' : 'block';
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    if (priceEl) priceEl.textContent = rpFmt(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = rpFmt(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    /* Update URL without pushing history */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url.toString());

    /* Swap gallery to variant image if it exists */
    if (variant.featured_image && mainImg) {
      var imgUrl = variant.featured_image.src.replace(/(\.[^.]+)$/, '_800x800$1');
      mainImg.src = imgUrl;
    }
  }

  variantSelects.forEach(function(sel) {
    sel.addEventListener('change', function() {
      updateUI(getCurrentVariant());
    });
  });

  /* Stale ?variant= on page load */
  var urlParams = new URLSearchParams(window.location.search);
  var urlVariantId = parseInt(urlParams.get('variant'), 10);
  if (urlVariantId && variantMap[urlVariantId]) {
    var v = variantMap[urlVariantId];
    variantSelects.forEach(function(sel) {
      var idx = parseInt(sel.dataset.optionIndex, 10);
      if (v.options[idx] !== undefined) sel.value = v.options[idx];
    });
    updateUI(v);
  } else if (urlVariantId && !variantMap[urlVariantId]) {
    /* Invalid variant ID — default to first available */
    var firstAvail = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    variantSelects.forEach(function(sel) {
      var idx = parseInt(sel.dataset.optionIndex, 10);
      if (firstAvail && firstAvail.options[idx] !== undefined) sel.value = firstAvail.options[idx];
    });
    updateUI(firstAvail || null);
  }

  /* Quantity buttons */
  var qtyInput = section.querySelector('[data-qty-input]');
  var qtyDec = section.querySelector('[data-qty-dec]');
  var qtyInc = section.querySelector('[data-qty-inc]');
  if (qtyDec && qtyInput) {
    qtyDec.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
  }
  if (qtyInc && qtyInput) {
    qtyInc.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  /* Add to cart form */
  var atcForm = section.querySelector('[data-atc-form]');
  var atcFeedback = section.querySelector('[data-atc-feedback]');

  function setFeedback(msg, type) {
    if (!atcFeedback) return;
    atcFeedback.textContent = msg;
    atcFeedback.className = 'rp-atc-feedback' + (type ? ' is-' + type : '');
  }

  if (atcForm && atcBtn) {
    atcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variant = getCurrentVariant();
      if (!variant || !variant.available) return;

      var qty = parseInt((qtyInput && qtyInput.value) || 1, 10);
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      setFeedback('', '');

      rpPost('/cart/add.js', { id: variant.id, quantity: qty })
        .then(function(res) {
          if (!res.ok) {
            var errMsg = (res.data && res.data.description) || 'Could not add item. Please try again.';
            setFeedback(errMsg, 'error');
            rpAnnounce(errMsg);
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to Cart';
            return;
          }
          /* Check for over-stock: fetch cart and compare */
          rpGet('/cart.js').then(function(cart) {
            var lineItem = cart.items.find(function(i) { return i.variant_id === variant.id; });
            var actualQty = lineItem ? lineItem.quantity : qty;
            if (actualQty < qty) {
              setFeedback('Only ' + actualQty + ' available.', 'error');
            } else {
              setFeedback('Added to cart!', 'success');
              rpAnnounce('Added to cart. Cart now has ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + '.');
            }
            /* Update cart count in header */
            var badges = document.querySelectorAll('.rp-cart-count');
            badges.forEach(function(b) {
              b.textContent = cart.item_count;
              b.dataset.count = cart.item_count;
            });
            atcBtn.disabled = !variant.available;
            atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          });
        })
        .catch(function() {
          setFeedback('Network error. Please try again.', 'error');
          rpAnnounce('Network error. Please try again.');
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        });
    });
  }
}

/* ─── Cart page ───────────────────────────────────────────────────────────────── */
function rpInitCart(section) {
  /* Qty change via +/- */
  section.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.dataset.key;
    var row = btn.closest('[data-cart-row]');
    var input = row && row.querySelector('[data-cart-qty-input]');
    var currentQty = input ? parseInt(input.value, 10) : 1;
    var delta = btn.dataset.cartQty === 'inc' ? 1 : -1;
    var newQty = Math.max(1, currentQty + delta);
    if (newQty === currentQty) return;
    rpChangeQty(key, newQty, row, input);
  });

  /* Remove link */
  section.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.dataset.cartRemove;
    var row = btn.closest('[data-cart-row]');
    rpChangeQty(key, 0, row, null);
  });

  function rpChangeQty(key, qty, row, input) {
    rpChange('/cart/change.js', { id: key, quantity: qty })
      .then(function() {
        return rpGet('/cart.js');
      })
      .then(function(cart) {
        if (qty === 0 && row) {
          row.remove();
          rpAnnounce('Item removed from cart.');
        } else if (input) {
          input.value = qty;
          rpAnnounce('Quantity updated.');
        }
        /* Re-render totals from live cart data */
        rpRenderCartTotals(cart);
        var badges = document.querySelectorAll('.rp-cart-count');
        badges.forEach(function(b) {
          b.textContent = cart.item_count;
          b.dataset.count = cart.item_count;
        });
        if (cart.item_count === 0) {
          var emptyEl = section.querySelector('.rp-cart-empty-state');
          if (emptyEl) emptyEl.style.display = 'block';
          var tableEl = section.querySelector('.rp-cart-table-wrap');
          if (tableEl) tableEl.style.display = 'none';
          var summaryEl = section.querySelector('.rp-cart-summary');
          if (summaryEl) summaryEl.style.display = 'none';
        }
      })
      .catch(function() {
        rpAnnounce('Could not update cart. Please refresh and try again.');
      });
  }

  function rpRenderCartTotals(cart) {
    var subtotalEl = section.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = rpFmt(cart.total_price);
    var totalEl = section.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = rpFmt(cart.total_price);
  }

  /* Warn about at-risk stock on page load */
  var rows = section.querySelectorAll('[data-cart-row]');
  rows.forEach(function(row) {
    var invQty = parseInt(row.dataset.invQty || '999', 10);
    var cartQty = parseInt(row.dataset.cartQty2 || '0', 10);
    if (cartQty > invQty && invQty > 0) {
      var warn = row.querySelector('.rp-cart-item-warning');
      if (warn) warn.style.display = 'block';
    }
  });
}

/* ─── Theme editor ────────────────────────────────────────────────────────────── */
document.addEventListener('shopify:section:load', function(e) {
  var section = e.target;
  if (section.querySelector('[data-product-json]')) rpInitProduct(section);
  if (section.querySelector('[data-cart-form]')) rpInitCart(section);
});

/* ─── Search overlay ─────────────────────────────────────────────────────────── */
function rpInitSearch() {
  var toggle = document.getElementById('rp-search-toggle');
  var overlay = document.getElementById('rp-search-overlay');
  var closeBtn = document.getElementById('rp-search-close');
  var input = document.getElementById('rp-search-input');
  if (!toggle || !overlay) return;

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (input) setTimeout(function() { input.focus(); }, 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }

  toggle.addEventListener('click', function() {
    overlay.classList.contains('is-open') ? closeSearch() : openSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });
}

/* ─── Client-side product filters (price + brand) ────────────────────────────── */
function rpInitProductFilters() {
  var minInput = document.getElementById('rp-price-min');
  var maxInput = document.getElementById('rp-price-max');
  var applyBtn = document.getElementById('rp-price-apply');
  var resetBtn = document.getElementById('rp-price-reset');
  var grid = document.querySelector('.rp-product-grid');
  if (!grid) return;

  function getActiveBrands() {
    var cbs = document.querySelectorAll('.rp-brand-filter-cb');
    var active = [];
    cbs.forEach(function(cb) { if (cb.checked) active.push(cb.value); });
    return active;
  }

  function applyFilters() {
    var minCents = minInput && minInput.value ? parseFloat(minInput.value) * 100 : 0;
    var maxCents = maxInput && maxInput.value ? parseFloat(maxInput.value) * 100 : Infinity;
    var activeBrands = getActiveBrands();
    var allBrandCbs = document.querySelectorAll('.rp-brand-filter-cb');

    grid.querySelectorAll('[data-price-cents]').forEach(function(card) {
      var price = parseInt(card.dataset.priceCents, 10) || 0;
      var vendor = card.dataset.vendor || '';
      var priceOk = price >= minCents && price <= maxCents;
      var brandOk = allBrandCbs.length === 0 || activeBrands.length === 0 || activeBrands.indexOf(vendor) !== -1;
      card.style.display = (priceOk && brandOk) ? '' : 'none';
    });

    if (resetBtn) {
      var hasPriceFilter = (minInput && minInput.value) || (maxInput && maxInput.value);
      var hasBrandFilter = activeBrands.length < allBrandCbs.length;
      resetBtn.style.display = (hasPriceFilter || hasBrandFilter) ? '' : 'none';
    }
  }

  function resetFilters() {
    if (minInput) minInput.value = '';
    if (maxInput) maxInput.value = '';
    document.querySelectorAll('.rp-brand-filter-cb').forEach(function(cb) { cb.checked = true; });
    grid.querySelectorAll('[data-price-cents]').forEach(function(c) { c.style.display = ''; });
    if (resetBtn) resetBtn.style.display = 'none';
  }

  if (applyBtn) applyBtn.addEventListener('click', applyFilters);
  if (resetBtn) resetBtn.addEventListener('click', resetFilters);
  if (minInput) minInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') applyFilters(); });
  if (maxInput) maxInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') applyFilters(); });

  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('rp-brand-filter-cb')) applyFilters();
  });
}

/* Keep old name as alias for boot call */
function rpInitPriceFilter() { rpInitProductFilters(); }

/* ─── Mobile nav accordion (Victron sub-links) ────────────────────────────────── */
function rpInitMobileAccordion() {
  var btns = document.querySelectorAll('.rp-mobile-accordion-btn');
  btns.forEach(function(btn) {
    var targetId = btn.getAttribute('aria-controls');
    var panel = targetId ? document.getElementById(targetId) : null;
    if (!panel) return;

    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (expanded) {
        panel.hidden = true;
      } else {
        panel.hidden = false;
      }
    });
  });
}

/* ─── Boot ────────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  rpInitMobileMenu();
  rpInitMobileAccordion();
  rpInitSearch();
  rpInitFilterDrawer();
  rpInitQuickAdd();
  rpInitPriceFilter();
  rpUpdateCartCount();
  rpInitCookieBanner();

  var productSection = document.querySelector('[data-section-type="main-product"]');
  if (productSection) rpInitProduct(productSection);

  var cartSection = document.querySelector('[data-section-type="main-cart"]');
  if (cartSection) rpInitCart(cartSection);
});

/* ─── Collection filter drawer (mobile) ──────────────────────────────────────── */
function rpInitFilterDrawer() {
  var toggle = document.getElementById('rp-filter-toggle');
  var sidebar = document.getElementById('rp-filter-sidebar');
  var closeBtn = document.getElementById('rp-filter-close');
  if (!toggle || !sidebar) return;

  /* Inject overlay */
  var overlay = document.createElement('div');
  overlay.className = 'rp-filter-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  document.body.appendChild(overlay);

  var scrollY = 0;

  function openFilters() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    sidebar.classList.add('is-open');
    overlay.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeFilters() {
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }

  toggle.addEventListener('click', function() {
    if (sidebar.classList.contains('is-open')) closeFilters(); else openFilters();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeFilters);
  overlay.addEventListener('click', closeFilters);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeFilters();
  });

  var mql = window.matchMedia('(min-width: 1024px)');
  function onBreak(e) { if (e.matches && sidebar.classList.contains('is-open')) closeFilters(); }
  if (mql.addEventListener) mql.addEventListener('change', onBreak);
  else mql.addListener(onBreak);
}

/* ─── Quick-add (single-variant products on collection pages) ─────────────────── */
function rpInitQuickAdd() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var variantId = parseInt(btn.dataset.quickAdd, 10);
    var title = btn.dataset.productTitle || 'Item';
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    rpPost('/cart/add.js', { id: variantId, quantity: 1 })
      .then(function(res) {
        if (!res.ok) {
          var msg = (res.data && res.data.description) || 'Could not add item.';
          rpAnnounce(msg);
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          return;
        }
        rpAnnounce('Added ' + title + ' to cart');
        rpUpdateCartCount();
        btn.textContent = '✓ Added!';
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function() {
        rpAnnounce('Network error. Please try again.');
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
  });
}

/* ─── Cookie consent banner ─────────────────────────────────────────────────── */
function rpInitCookieBanner() {
  var CONSENT_KEY = 'rp_consent';
  var banner = document.getElementById('rp-cookie-banner');
  if (!banner) return;

  function getStored() {
    try { return JSON.parse(localStorage.getItem(CONSENT_KEY)); } catch (e) { return null; }
  }

  function saveConsent(value) {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ value: value, version: 1, ts: Date.now() }));
    } catch (e) {} // Safari private mode throws QuotaExceededError
  }

  function updateGtag(granted) {
    if (typeof gtag === 'function') {
      var state = granted ? 'granted' : 'denied';
      gtag('consent', 'update', {
        analytics_storage: state,
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state
      });
    }
  }

  function showBanner() { banner.classList.remove('rp-cookie-hidden'); }
  function hideBanner() { banner.classList.add('rp-cookie-hidden'); }

  function handleAccept() {
    updateGtag(true);
    saveConsent('accepted');
    hideBanner();
  }

  function handleDecline() {
    updateGtag(false);
    saveConsent('declined');
    hideBanner();
  }

  var stored = getStored();
  if (!stored) showBanner();

  document.getElementById('rp-cookie-accept').addEventListener('click', handleAccept);
  document.getElementById('rp-cookie-decline').addEventListener('click', handleDecline);

  document.querySelectorAll('[data-rp-cookie-reopen]').forEach(function(el) {
    el.addEventListener('click', function() {
      try { localStorage.removeItem(CONSENT_KEY); } catch (e) {}
      showBanner();
    });
  });
}
